<template>
  <nav v-bind="$attrs" class="flex flex-wrap items-center text-sm">
    <div class="flex items-center whitespace-nowrap">
      <Link
        class="text-gray-800 hover:underline"
        :href="route('checkout.cart', order)"
        text="Warenkorb"
      />
      <Icon
        type="angle-right"
        class="flex-none text-gray-500 mx-1"
        size="3"
      />
    </div>
    <template v-for="(text, key) in links">
      <div class="flex items-center whitespace-nowrap">
        <span v-if="step === key" class="text-blue-500">{{ text }}</span>
        <Link
          v-else-if="steps[key] !== false"
          class="text-gray-800 hover:underline"
          :href="route('checkout', { order, step: key })"
          :text="text"
        />
        <span v-else class="text-gray-500">{{ text }}</span>
        <Icon
          v-if="!last(key)"
          type="angle-right"
          class="flex-none text-gray-500 mx-1"
          size="3"
        />
      </div>
    </template>
  </nav>
</template>

<script>
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';

export default {
  inheritAttrs: false,
  components: {
    Icon,
    Link,
  },
  props: {
    order: Object,
    steps: Object,
    step: String,
  },
  setup() {
    const links = {
      contact:  'Information',
      shipping: 'Versand',
      payment:  'Zahlung',
      conclude: 'Überprüfung',
    };

    function last(key) {
      return !Object.keys(links).reverse().indexOf(key);
    }

    return {
      links,
      last,
    }
  }
}
</script>
